function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import ActionButton from "./ActionButton";
import ActionDropdown from "./ActionDropdown";
import ActionMenu from "./ActionMenu";
const useStyles = makeStyles(theme => ({
  root: {
    fontSize: "14px" //        margin: theme.spacing(1),

  }
}));

const NavAction = ({
  className,
  variant = "contained",
  color = "primary",
  placement = "bottom-start",
  primaryAction,
  menu = [],
  onSelect
}) => {
  const _useState = useState(false),
        expanded = _useState[0],
        setExpanded = _useState[1];

  const anchorRef = useRef(null);
  const classes = useStyles();

  const handleToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const handleSelect = (_ref) => {
    let onClick = _ref.onClick,
        item = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

    onClick && onClick() || onSelect && onSelect(item);
    setExpanded(false);
  };

  if (!primaryAction && menu.length) {
    primaryAction = menu[0];
  }

  if (primaryAction && primaryAction.children) {
    const menu = primaryAction.children;
    const role = primaryAction.role;

    if (role !== "button") {
      return React.createElement("nav", {
        className: className || classes.root
      }, React.createElement(ActionButton, _extends({}, primaryAction, {
        variant: primaryAction.variant || variant,
        color: color,
        expanded: expanded,
        forwardedRef: anchorRef,
        onToggle: handleToggle
      })), React.createElement(Popper, {
        open: expanded,
        style: {
          zIndex: 2000
        },
        role: undefined,
        transition: true,
        anchorEl: anchorRef.current,
        placement: placement
      }, React.createElement(ClickAwayListener, {
        onClickAway: handleToggle
      }, React.createElement(ActionDropdown, null, React.createElement(ActionMenu, {
        menu: menu,
        onSelect: handleSelect
      })))));
    }

    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(ActionButton, _extends({}, primaryAction, {
      variant: primaryAction.variant || variant,
      color: color,
      expanded: expanded,
      forwardedRef: anchorRef,
      onClick: () => handleSelect(primaryAction),
      onToggle: handleToggle
    })), React.createElement(Popper, {
      open: expanded,
      style: {
        zIndex: 2000
      },
      role: undefined,
      transition: true,
      anchorEl: anchorRef.current,
      placement: placement
    }, React.createElement(ClickAwayListener, {
      onClickAway: handleToggle
    }, React.createElement(ActionDropdown, null, React.createElement(ActionMenu, {
      menu: menu,
      onSelect: handleSelect
    })))));
  }

  if (primaryAction) {
    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(ActionButton, _extends({}, primaryAction, {
      variant: primaryAction.variant || variant,
      color: color,
      onClick: () => handleSelect(primaryAction)
    })));
  }

  return null;
};

export default NavAction;